import React from "react";
import Router from "next/router";

import {
  MainBox,
  SearchDetailForm,
  TimeRange,
  ParamToQueryItem,
} from "@vrw-guppy/react-vrw";

const ItemList = ({
  type,
  query,
  seathKeys = [],
}: {
  type: string;
  query: any;
  seathKeys: {
    label: string;
    value: string;
    type: "number" | "string" | "datetime";
    enabled: boolean;
  }[];
}) => {
  const isDatetime = (key: string) => {
    const target = seathKeys.filter((k) => k.value === key);
    return target.length ? target[0].type === "datetime" : false;
  };
  const movePage = (params: any) => {
    params = params.map((p: any) => `${p.key}=${p.value}`);
    const path = `/${type}/?${params.join("&")}`;
    Router.push(path);
  };

  const queries: any[] = Object.keys(query).map((key) => {
    let pld = { key };
    if (isDatetime(key)) {
      pld = TimeRange.fromString(query[key]).toQueryItem(key);
    } else {
      pld = ParamToQueryItem(`${key}=${query[key]}`);
    }
    return {
      ...pld,
      enabled: true,
    };
  });

  return (
    <>
      <MainBox>
        <SearchDetailForm
          onSubmit={async (queries: string[]) => {
            movePage(
              (queries || []).map((p) => {
                return {
                  key: p.split("=")[0],
                  value: p.split("=")[1],
                };
              })
            );
          }}
          keys={seathKeys}
          queries={queries}
        />
      </MainBox>
    </>
  );
};

export default ItemList;
